var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1748_46117)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.44409C4.29 1.44409 0 5.23009 0 8.43309C0 10.8331 1.558 12.9501 3.931 14.2081L2.933 17.8741C2.844 18.1991 3.213 18.4571 3.496 18.2701L7.873 15.3651C8.242 15.4011 8.618 15.4221 9 15.4221C13.97 15.4221 18 12.2931 18 8.43309C18 5.23009 13.97 1.44409 9 1.44409Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1748_46117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/Kakao.b45c0f5ad0cc661a3884209210c95ba5.svg";
export { ForwardRef as ReactComponent };